import {Component, Injector, OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {MapItem} from "@capturum/ui/api";
import {TranslateService} from "@ngx-translate/core";
import {IntBaseListComponent} from "@shared/base/int-base-list.component";
import {PageConfig} from "@core/models/page-config.model";
import {FormBuilder, FormGroup} from "@angular/forms";
import {RegionAnalysisService} from "@features/dashboard-rmc-reports/services/region-analysis.service";
import {BlobService} from "@core/services/blob.service";
import {DateParserPipe} from "@shared/pipes/date-parser/date-parser.pipe";
import {FontAwesomeIcon} from "@core/enums/font-awesome-icon.enum";
import {ButtonLoadingAnimationService} from "@shared/services/button-loading-animation.service";
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-region-analysis',
    templateUrl: './region-analysis.component.html',
    styleUrl: './region-analysis.component.scss',
    standalone: false
})
export class RegionAnalysisComponent extends IntBaseListComponent<any> implements OnInit {
    public regionOptions$: BehaviorSubject<MapItem[]> = new BehaviorSubject([]);
    public form: FormGroup;
    public downloadIcon: FontAwesomeIcon = FontAwesomeIcon.Download;
    public disabledSubmit = true;
    constructor(
        injector: Injector,
        public translateService: TranslateService,
        public apiService: RegionAnalysisService,
        private blobService: BlobService,
        private dateParserPipe: DateParserPipe,
        private buttonLoadingAnimationService: ButtonLoadingAnimationService,
        private fb: FormBuilder,
    ) {
        super(injector);
    }

    public getDefaultConfig(): PageConfig {
        return {
            title: this.translateService.instant('dashboard-rmc.dashboard-reports.region-analysis.label'),
            buttons: [],
        };
    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.form = this.fb.group({
            regionYear: [null],
        });

        this.form.get('regionYear')?.valueChanges.subscribe((value) => {
            this.disabledSubmit = !value;
        });

        this.apiService.getAvailableRegionYears().subscribe((regionYears: any) => {
            const sortedYears = regionYears.data.sort((a, b) => Number(b.key) - Number(a.key));

            this.regionOptions$.next(sortedYears.map((regionYear) => ({
                value: regionYear.key,
                key: regionYear.key,
                label: regionYear.label
            })));
        });
    }

    public onSubmit(): void {
        const selectedRegionYear = this.form.get('regionYear')?.value;
        const selector = '.download-button';
        const originalIcon = FontAwesomeIcon.Download;
        this.buttonLoadingAnimationService.disableButton(selector, originalIcon);

        this.apiService.downloadFile(selectedRegionYear).pipe(
            finalize(() => {
                this.buttonLoadingAnimationService.enableButton(selector, originalIcon);
            })
        ).subscribe({
            next: (response) => {
                const filename = `${this.dateParserPipe.transform(new Date(), 'yMMd_Hmm')}_regio-analyse.docx`;
                this.blobService.downloadBlobAsFile(response, response.type, filename);
            },
        });
    }
}
